<template>
  <select
    class="form-control select2-ajax"
    :name="options['column']"
    :data-get-items-route="relationUrl"
    :data-get-items-field="row['field']"
    :data-id="dataTypeContentSearch['getKey']"
    :data-method="dataTypeContentSearch['getKey'] ? 'edit' : 'add'"
    :value="getInputValue"
  >
    <option v-if="!row['required']" value="">{{ voyagerGenericNone }}</option>
    <option
      v-for="(data, index) in relationshipData"
      :key="index"
      :value="data[options['key']]"
    >
      {{ data[options["label"]] }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    pageSearch: {
      type: Object,
      default: () => ({}),
    },
    relationUrl: {
      type: String,
      default: "",
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    dataTypeContentSearch: {
      type: Object,
      default: () => ({}),
    },
    relationshipData: {
      type: Object,
      default: () => ({}),
    },
    voyagerGenericNone: {
      type: String,
      default: "",
    },
    oldInput: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getInputValue() {
      const searchValue = this.pageSearch[this.options["column"]]
        ? this.pageSearch[this.options["column"]]
        : "";
      const oldValue = this.oldInput[this.options["column"]]
        ? this.oldInput[this.options["column"]]
        : searchValue;
      return oldValue;
    },
  },
};
</script>